import {
  createContext,
  useContext,
} from 'react';

export type TCustomModalContext = {
  isOpen: boolean;
};

export const CustomModalContext = createContext<TCustomModalContext | null>(
  null,
);

export const useCustomModalContext = () => {
  const context = useContext(CustomModalContext);

  if (context === null) {
    throw new Error('useCustomModalContext must be within provider');
  }

  return context;
};
